<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core"
import type { PrimitiveProps } from "reka-ui"
import { Primitive } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { computed } from "vue"

import { useCommand } from "@/components/ui/command"
import { cn } from "@/lib/utils"

const props = defineProps<
  PrimitiveProps & { class?: HTMLAttributes["class"] }
>()

const delegatedProps = reactiveOmit(props, "class")

const { filterState } = useCommand()
const isRender = computed(
  () => !!filterState.search && filterState.filtered.count === 0,
)
</script>

<template>
  <Primitive
    v-if="isRender"
    data-slot="command-empty"
    v-bind="delegatedProps"
    :class="cn('py-2 text-center text-sm', props.class)"
  >
    <slot />
  </Primitive>
</template>
